<template>
  <div>
    <div class="section operations" style="height: 100%">
      <div v-show="cooperateEdit" class="triggers">
        <cargo-button-group-slider>
          <el-button no="1" type="primary" :disabled="readonly || sendToPlatformUnlock" @click="pm.addBtnClickHandler()">{{ $t('SeaExport.Add2') }}</el-button>
          <el-button no="2" type="danger" :disabled="readonly || sendToPlatformUnlock" @click="pm.delBtnClickHandler()">{{ $t('SeaExport.Delete') }}</el-button>
          <el-button no="3" type="primary" @click="pm.downTemplateBtn_clickHandler()">{{ $t('SeaExport.TemplateDownload') }}</el-button>
          <el-upload
            no="4"
            :disabled="readonly || sendToPlatformUnlock"
            :action="URL.seaExport.poItemsImportExcel"
            :headers="{sessionId:user.sessionId}"
            :data="{ jobUuid: job.uuid, jobNo: job.jobNo }"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            style="display: inline-block;margin-left: 5px;"
          >
            <el-button type="primary" :disabled="readonly || sendToPlatformUnlock">{{ $t('SeaExport.ExcelImport') }}</el-button>
          </el-upload>
          <el-button no="5" :disabled="readonly || sendToPlatformUnlock" type="primary" @click="pm.exportBtnClickHandler()">{{ $t('SeaExport.ExcelExport') }}</el-button>
          <el-button no="6" type="success" @click="pm.onBatchPrint()">{{ $t('SeaExport.print') }}</el-button>
          <el-button v-show="$checkPermission(['button_AEBooking_sendJdy']) && sendToPlatform" no="7" type="primary" @click="pm.sendToJdyPlatform()">{{ $t('SeaExport.sendJdy') }}</el-button>
          <el-button v-show="$checkPermission(['button_AEBooking_unlockJdy']) && sendToPlatform && sendToPlatformUnlock" no="8" type="primary" @click="pm.sendToPlatformUnlock()">{{ $t('CargoMsg.Cargo_UnLockLabel') }}</el-button>
          <el-button
            v-show="$checkPermission(['button_container_BoxListRecognition'])"
            no="9"
            type="primary"
            :disabled="isEdit"
            @click="boxListRecognition"
          >
            {{ $t('SeaExport.IdentifyPackingList') }}
          </el-button>
        </cargo-button-group-slider>
      </div>
      <div style="height: 100%; margin-top: 5px;">
        <cargo-ag-grid
          config-module="1153"
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="columnDefs"
          :row-data="poItems"
          style="width:100%;height:100%"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
    </div>
    <!-- 添加装箱信息弹出窗 -->
    <trade-detail-container-linked-dialog
      :visible.sync="tradeDetailContainerLinkedDialog.visible"
      :job="job"
      :sel-po-items="tradeDetailContainerLinkedDialog.selPoItems"
      :related-container-usage="tradeDetailContainerLinkedDialog.relatedContainerUsage"
      @linkUsagesEventHandler="linkUsagesEventHandler"
    />

    <!-- 识别装箱单-弹窗 -->
    <box-list-recognition-dialog
      :visible.sync="recognitionDialog.visible"
      :job="recognitionDialog.job"
      :user-info="recognitionDialog.userInfo"
      @refresh="refreshTradeDetail"
    />

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

import { TabTradeDetailBase } from './TabTradeDetailBase'
import { AbstractEntity as Job } from '@/class/model/AbstractEntity'
import TradeDetailContainerLinkedDialog
  from '@/components/Cargo/Job/tradeDetailContainerLinkedDialog'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { basicCacheKeys as selectTypeNames } from '@/utils/cacheConfig'
import ColumnUtils from '@/utils/ColumnUtils'
import { formatNumberToThousands } from '@/utils'
import { isNumber } from '@/utils/validate'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { getGridSelected } from '@/utils/agGrid'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import { deepCopy } from '@/utils/commonUtil'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import LocalStorageUtils from '@/utils/localStorageUtils'
import BoxListRecognitionDialog from '@/components/Cargo/Job/BoxListRecognitionDialog'
import CargoAiRecognitionDialog from '@/views/cargo/v0/SeaExport/components/booking/ams/cargoAiRecognitionDialog.vue'

export default {
  name: 'TabTradeDetail',
  components: { CargoAiRecognitionDialog, TradeDetailContainerLinkedDialog, cargoTemplateSelectorDialog, CargoButtonGroupSlider, BoxListRecognitionDialog },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      URL,
      pm: new TabTradeDetailBase(this),
      selectTypeNames: TYPE_NAMES,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: { // 添加编辑组件
          CargoAgGridCommonTextareaEditor,
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonInputEditor
        }
      },
      rowData: [],
      gridApi: null,
      tradeDetailContainerLinkedDialog: {
        visible: false,
        selPoItems: [],
        relatedContainerUsage: []
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: new AirExportJob(),
        category: 'AEPOITEMS',
        data: {
          POITEMS_UUID: []
        }
      },
      job: new Job().fillDefaultValue().getData(),
      poItems: [],
      delPoItemsUuids: [], // 删除的uuid
      sendToPlatform: false,
      sendToPlatformUnlock: false,
      isUppercaseByConfig: true, // CARGO-49117 是否大写
      // 识别装箱单弹窗
      recognitionDialog: {
        visible: false,
        job: { },
        userInfo: { }
      }
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    user() {
      return this.context.user || {}
    },
    columnDefs() {
      let columnDefs =
         [
           {
             headerName: '',
             field: '',
             width: 65,
             headerCheckboxSelection: true,
             checkboxSelection: true,
             sortable: false,
             suppressMenu: true,
             suppressSizeToFit: true,
             resizable: false
           },
           {
             headerName: this.$t('SeaExport.OrderNo'),
             colId: 'orderNo',
             field: 'orderNo',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: 'ACPT',
             field: 'moduleCode',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.CaseNo'),
             field: 'caseNo',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.Item'),
             field: 'itemNo',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.Sub'),
             field: 'subItemNo',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: 'SUPPLY PARTS NO',
             field: 'supplyPartNo',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: 'ORDER PARTS NO',
             field: 'orderPartNo',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: 'HS CODE',
             field: 'hsCode',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.isRelated'),
             field: 'related',
             width: 120,
             hide: true,
             cellRenderer: (params) => {
               return this.relatedLabelFunc(params.value)
             }
           },
           {
             headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
             field: 'chineseCommodity',
             width: 120,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonTextareaEditor'
           },
           {
             headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
             field: 'englishCommodity',
             width: 120,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonTextareaEditor',
             cellEditorParams: {
               autoUppercase: this.isUppercaseByConfig
             }
           },
           {
             headerName: this.$t('SeaExport.Size2'),
             field: 'itemSpec',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.CommodityClassification'),
             field: 'customsCommodity',
             width: 100,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonTextareaEditor'
           },
           {
             headerName: this.$t('SeaExport.Qty'),
             field: 'quantity',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.UnitOfMeasurement'),
             field: 'measure',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.NetWeight'),
             field: 'netWeight',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: 'WEIGHT',
             field: 'grossWeight',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.Cubage'),
             field: 'cubage',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: 'AMOUNT',
             field: 'purchaseAmount',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               },
               valueChanged: params => {
                 return this.pm.calculateAmount(params.data)
               }
             }
           },
           {
             headerName: 'AMOUNT(RMB)',
             field: 'purchaseAmountRMB',
             width: 150,
             cellRenderer: (params) => {
               return this.purchaseAmountRMBLabelFun(params.data)
             }
           },
           {
             headerName: this.$t('SeaExport.CustomsDutyRate'),
             field: 'purchaseTariffRate',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               },
               valueChanged: params => {
                 this.pm.calculateAmount(params.data)
               }
             }
           },
           {
             headerName: this.$t('SeaExport.CustomsDuties'),
             field: 'purchaseTariffAmount',
             width: 120
           },
           {
             headerName: this.$t('SeaExport.IncrementValueDutyRate'),
             field: 'purchaseValRate',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               },
               valueChanged: params => {
                 this.pm.calculateAmount(params.data)
               }
             }
           },
           {
             headerName: this.$t('SeaExport.IncrementValueDuty'),
             field: 'purchaseValAmount',
             width: 120
           },
           {
             headerName: this.$t('SeaExport.ConsumptionDutyRate'),
             field: 'purchaseExciseRate',
             width: 110,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               },
               valueChanged: params => {
                 this.pm.calculateAmount(params.data)
               }
             }
           },
           {
             headerName: this.$t('SeaExport.ConsumptionDuty'),
             field: 'purchaseExciseAmount',
             width: 100
           },
           {
             headerName: this.$t('SeaExport.ConsolidatedTax'),
             field: 'totalRateAmount',
             width: 100,
             cellRenderer: (params) => {
               return this.totalRateAmountLabelFun(params.data)
             }
           },
           {
             headerName: this.$t('SeaExport.Currency'),
             field: 'purchaseCurrency',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-advance-select',
               selectType: selectTypeNames.basic_data_Currency,
               tagValue: 'code',
               tagName: 'code'
             }
           },
           {
             headerName: this.$t('SeaExport.ExchangeRate'),
             field: 'pruchaseExchangeRate',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               },
               valueChanged: params => {
                 this.pm.calculateAmount(params.data)
               }
             }
           },
           {
             headerName: this.$t('SeaExport.CargoPrice'),
             field: 'sellPrice',
             width: 100
           },
           {
             headerName: this.$t('SeaExport.Tax'),
             field: 'sellValAmount',
             width: 100
           },
           {
             headerName: this.$t('SeaExport.TaxRate'),
             field: 'sellValRate',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.BigBagNo'),
             field: 'bigBagNo',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.BigBagWeight'),
             field: 'bigBagWeight',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.BigBagWeightUnit'),
             field: 'bigBagWeightUnit',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.BigBagLength'),
             field: 'bigBagLength',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.BigBagWidth'),
             field: 'bigBagWidth',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.BigBagHeight'),
             field: 'bigBagHeight',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.BigBagDimensionUnit'),
             field: 'bigBagDimensionUnit',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.BigBagGoodsType'),
             field: 'bigBagGoodsType',
             width: 140,
             hide: true,
             valueFormatter: (params) => {
               if (!params.data && params.value === undefined) {
                 return ''
               }
               return ColumnUtils.bigBagGoodsType(params.value)
             },
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridAdvanceSelectEditor',
             cellEditorParams: {
               selectProps: {
                 tagValue: 'code',
                 tagName: 'chineseName',
                 staticOptions: SystemConstants.ALL_BIG_BAG_GOODS_TYPE
               }
             }
           },
           {
             headerName: this.$t('SeaExport.FulfillmentLabel'),
             field: 'fulfillmentLabel',
             width: 140,
             hide: true,
             valueFormatter: (params) => {
               if (!params.data && params.value === undefined) {
                 return ''
               }
               return ColumnUtils.fulfillmentLabel(params.value)
             },
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridAdvanceSelectEditor',
             cellEditorParams: {
               selectProps: {
                 tagValue: 'code',
                 tagName: 'chineseName',
                 staticOptions: SystemConstants.ALL_FULFILLMENT_LABEL
               }
             }
           },
           {
             headerName: this.$t('SeaExport.LandingPort'),
             field: 'landingPort',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.PackageQuantity'),
             field: 'packageQuantity',
             width: 140,
             hide: true,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.ExpectPickupStartTime'),
             field: 'expectPickupStartTime',
             width: 140,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.ExpectPickupEndTime'),
             field: 'expectPickupEndTime',
             width: 140,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.PreviousCarrierCode'),
             field: 'previousCarrierCode',
             width: 140,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.PreviousResourceCode'),
             field: 'previousResourceCode',
             width: 140,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.NextCarrierCode'),
             field: 'nextCarrierCode',
             width: 140,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.NextResourceCode'),
             field: 'nextResourceCode',
             width: 140,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.SortCode'),
             field: 'sortCode',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('RailwayExport.destinationCountry'),
             field: 'buyerRegion',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.operationTime'),
             field: 'operateTime',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.AddressL0'),
             field: 'addressL0',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.AddressL1'),
             field: 'addressL1',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.AddressL2'),
             field: 'addressL2',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.AddressL3'),
             field: 'addressL3',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.AddressL4'),
             field: 'addressL4',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('RailwayExport.DetailedAddress'),
             field: 'details',
             width: 140,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.DetailsAddressMore'),
             field: 'detailsMore',
             width: 140,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.PickupFirstName'),
             field: 'pickupFirstName',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.PickupLastName'),
             field: 'pickupLastName',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.PickupCompany'),
             field: 'pickupCompany',
             width: 140,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.PickupZip'),
             field: 'pickupZip',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.PickupPhone'),
             field: 'pickupPhone',
             width: 140,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.TtOrderCode'),
             field: 'ttOrderCode',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.MwbNo'),
             field: 'mwbNo',
             width: 100,
             hide: true,
             editable: this.isEdit && !this.sendToPlatformUnlock,
             cellEditor: 'CargoAgGridCommonInputEditor'
           },
           {
             headerName: this.$t('SeaExport.BillingQTY'),
             headerTooltip: this.$t('SeaExport.BillingQTY'),
             field: 'billingQty',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               },
               valueChanged: params => {
                 params.data.billingQty = formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2))
               }
             }
           },
           {
             headerName: this.$t('CargoMsg.Cargo_InvoiceNo'),
             headerTooltip: this.$t('CargoMsg.Cargo_InvoiceNo'),
             field: 'invoiceNo',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit && !this.sendToPlatformUnlock,
               tag: 'cargo-cell-input',
               attrs: {
                 maxLength: 255
               }
             }
           }
         ]
      if (this.sendToPlatform) {
        columnDefs = [
          ...columnDefs,
          {
            headerName: this.$t('CargoMsg.Cargo_ResultSuccess'),
            colId: 'sendStatus',
            field: 'sendStatus',
            width: 150,
            cellRenderer: (params) => {
              return ColumnUtils.sendStatusJdyLabelFunction(params.value)
            },
            hide: true
          }, {
            headerName: this.$t('CargoMsg.Cargo_Sender'),
            colId: 'sender',
            field: 'sender',
            width: 150,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            },
            hide: true
          }, {
            headerName: this.$t('FinanceManage.sendingTime'),
            colId: 'sendingTime',
            field: 'sendingTime',
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            },
            width: 200,
            hide: true
          }
        ]
      }
      return columnDefs
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      this.sendToPlatformUnlock = Number(row.lockStatus) === 1
      if (!isRefresh) {
        return
      }
      this.job = row
      await this.pm.loadPoItems()
      if (this.isEdit && this.job.uuid) {
        this.$emit('syncData', { poItems: deepCopy(this.job.poItems) })
      }
      this.isUppercaseByConfig = Number(this.context.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
      if (this.context.config.get('sendToPlatform')) {
        this.sendToPlatform = this.context.config.get('sendToPlatform').toString().includes('jdy')
      }
    },
    // 保存
    getSubmitData() {
      return {
        poItems: this.poItems,
        delPoItemsUuids: this.delPoItemsUuids
      }
    },
    beforeUpload(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    uploadSuccess(response, file, fileList) {
      if (response && response.data) {
        this.pm.onImportSucceeded(response.data)
      } else {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    relatedLabelFunc(value) {
      return value === 1 ? this.$t('Message.Yes') : this.$t('Message.No')
    },
    totalRateAmountLabelFun(data) {
      const poItems = data
      if (poItems) {
        return Number(poItems.purchaseTariffAmount + poItems.purchaseValAmount + poItems.purchaseExciseAmount).toFixed(2)
      }
      return ''
    },
    purchaseAmountRMBLabelFun(data) {
      var poItems = data
      if (poItems) {
        return (Math.round(poItems.purchaseAmount * poItems.pruchaseExchangeRate)).toFixed(2)
      }
      return ''
    },
    // 添加装箱信息(选择后逻辑处理)
    linkUsagesEventHandler(data) {
      this.pm.linkUsagesEventHandler(data)
    },
    // 刷新货物明细数据
    refreshTradeDetail() {
      this.pm.loadPoItems(true)
    },
    // 组装打印参数
    getPrintData() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning('未选择货物明细!')
        return
      }
      const uuids = []
      for (const item of chooseRows) {
        uuids.push(item.uuid)
      }
      const params = {}
      params.POITEMS_UUID = uuids
      params.category = 'AEPOITEMS'
      params.jobuuid = this.job.uuid
      params.ctx = new AirExportJob(this.job)
      return params
    },
    boxListRecognition() {
      this.recognitionDialog.job = this.job
      this.recognitionDialog.userInfo = this.$store.getters.userInfo
      this.recognitionDialog.visible = true
    }
  }
}
</script>

<style>
</style>
